// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import ElementUI, { Form } from 'element-ui';
import mecompnents from './components/index'
import 'lib-flexible'
import { public_data } from './libs/public_data'
Vue.use(mecompnents)
import api from './api/apis'
Vue.prototype.$api = api
Vue.prototype.$public_data = public_data
    // console.log(public_data,9999)
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import animated from 'animate.css' // npm install animate.css --save安装，在引入
Vue.use(animated)
import $ from 'jquery'
Vue.prototype.$ = $
Vue.config.productionTip = false
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js